export default [
  {
    path: '/students',
    name: 'students',
    component: () => import('@/views/students/StudentsIndex.vue'),
    meta: {
      requiresAuth: true,
      title: 'Students',
      roles: ['sponsor', 'site_representative']
    }
  },
  {
    path: '/students/create',
    name: 'student-create',
    component: () => import('@/views/students/StudentCreate.vue'),
    meta: {
      requiresAuth: true,
      title: 'Add Student',
      roles: ['site_representative']
    }
  },
  {
    path: '/sites/:siteId/students/create',
    name: 'students.create',
    component: () => import('@/views/students/StudentCreate.vue'),
    meta: {
      requiresAuth: true,
      permission: 'students.create',
      title: 'Add Student',
      roles: ['site_representative']
    }
  },
  {
    path: '/students/:id',
    name: 'students.show',
    component: () => import('@/views/students/StudentShow.vue'),
    meta: {
      requiresAuth: true,
      permission: 'students.view',
      title: 'Student Details',
      roles: ['sponsor', 'site_representative']
    }
  },
  {
    path: '/students/:id/edit',
    name: 'students.edit',
    component: () => import('@/views/students/StudentEdit.vue'),
    meta: {
      requiresAuth: true,
      permission: 'students.edit',
      title: 'Edit Student',
      roles: ['site_representative']
    }
  },
  // Enrollment Form Routes
  {
    path: '/students/:studentId/enrollment',
    name: 'enrollment-form.show',
    component: () => import('@/views/enrollment/EnrollmentForm.vue'),
    meta: {
      requiresAuth: true,
      title: 'Enrollment Form',
      roles: ['sponsor', 'site_representative']
    }
  },
  {
    path: '/students/:studentId/enrollment/create',
    name: 'enrollment-form.create',
    component: () => import('@/views/enrollment/EnrollmentFormEdit.vue'),
    meta: {
      requiresAuth: true,
      title: 'Create Enrollment Form',
      roles: ['site_representative']
    }
  },
  {
    path: '/students/:studentId/enrollment/edit',
    name: 'enrollment-form.edit',
    component: () => import('@/views/enrollment/EnrollmentFormEdit.vue'),
    meta: {
      requiresAuth: true,
      title: 'Edit Enrollment Form',
      roles: ['site_representative']
    }
  }
]
